/**
 * „Cztery czynności" (T-C7) — what each of the ledger's four acts does, in the mobile help sheet's
 * words. Opened from the „?" beside the acts; „Rozumiem" and Escape close it and focus returns to
 * that button.
 */

import { Dialog } from '@base-ui/react/dialog';
import { useTranslation } from 'react-i18next';

import surface from '~/shared/ui/dialogSurface.module.css';
import form from '~/shared/ui/formDialog.module.css';
import { CloseGlyph } from '~/shared/ui/FormGlyphs';
import ink from '~/shared/ui/inkButton.module.css';
import { LEDGER_ACTS } from '~/features/credit-ledger';

import styles from './LedgerTab.module.css';

interface LedgerHelpDialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

const HELP = 'web:booking.trainer.credits.help';

export function LedgerHelpDialog({ open, onClose }: LedgerHelpDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop className={surface.backdrop} />
        <Dialog.Popup className={`${String(surface.popup)} ${String(styles.help)}`}>
          <div className={form.dialogHead}>
            <div>
              <span className={form.eyebrow}>{t('web:booking.trainer.credits.title')}</span>
              <Dialog.Title className={form.dialogTitle}>{t(`${HELP}.title`)}</Dialog.Title>
            </div>
            <Dialog.Close
              className={form.close}
              aria-label={t('web:booking.trainer.credits.sheet.close')}
            >
              <CloseGlyph className={form.closeGlyph} />
            </Dialog.Close>
          </div>
          <dl className={styles.helpRows}>
            {LEDGER_ACTS.map((act) => (
              <div key={act} className={styles.helpRow}>
                <dt className={styles.helpTitle}>{t(`${HELP}.rows.${act}.title`)}</dt>
                <dd className={styles.helpBody}>{t(`${HELP}.rows.${act}.body`)}</dd>
              </div>
            ))}
          </dl>
          <div className={form.dialogActs}>
            <button
              type="button"
              className={`${String(ink.ink)} ${String(styles.helpConfirm)}`}
              onClick={onClose}
            >
              {t('web:booking.credits.help.confirm')}
            </button>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
